import Vue from 'vue'
import { Quill, quillEditor, install } from 'vue-quill-editor'
import { ImageExtend } from 'quill-image-paste-module'

// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Quill.register('modules/ImageExtend', ImageExtend)

Vue.use({ Quill, quillEditor, install })
